<template>
  <div>
   <h5 class="font-weight-bolder mt-4">HOD Settings</h5>
<b-form-group>
  <span v-if="loadingHodInviteSettings" class="text-warning">Loading settings...</span>

  <div>
    <b-form-checkbox 
      @change="updateHodInviteSettings"
      v-model="allow_hod_invite_faculty"
      inline
    >
     Allow HODs to invite faculties
    </b-form-checkbox>
  </div>
</b-form-group>

  </div>
</template>

<script>
import axios from "axios";
export default {
   created() {
   this.getHodInviteSettings();
  },
  data() {
    return {
     allow_hod_invite_faculty: false,
loadingHodInviteSettings: false,
    };
  },
  methods: {
  
  async getHodInviteSettings() {

  const settingKey = "allow_hod_invite_faculty";
  let mainUrl = this.$store.getters.getAPIKey.institutionSettings;
  const url = mainUrl.replace("setting_key", settingKey);

  await axios
    .get(url)
    .then((response) => {
      let setting = response.data;
      if (setting) {
        this.allow_hod_invite_faculty = !!setting; // convert to boolean
      } else {
        this.allow_hod_invite_faculty = false; // default unchecked
      }
    })
    .catch(() => {
      this.$toast.error(`Failed to load HOD invite settings`, {
        top: "top",
        duration: 6000,
      });
    });

  this.loadingHodInviteSettings = false;
},

async updateHodInviteSettings() {
  this.loadingHodInviteSettings = true;
  const settingKey = "allow_hod_invite_faculty";
  let mainUrl = this.$store.getters.getAPIKey.institutionSettings;
  const url = mainUrl.replace("setting_key", settingKey);

  await axios
    .post(url, { allow_hod_invite_faculty: this.allow_hod_invite_faculty })
    .then(() => {
      this.$toast.success(`HOD invite settings updated`, {
        top: "top",
        duration: 3000,
      });
    })
    .catch(() => {
      this.$toast.error(`Failed to update HOD invite settings`, {
        top: "top",
        duration: 3000,
      });
    });

  this.loadingHodInviteSettings = false;
},

  },
};
</script>
